exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".eventdetails__schedule-presenters--no-profile[data-v-7c05efba]{font-size:44px!important}.eventdetails__schedule-presenters--no-img[data-v-7c05efba]{font-size:120px!important}@media screen and (max-width:959px){.eventdetails__schedule-presenters--no-img[data-v-7c05efba]{font-size:80px!important}}", ""]);

// exports
